var _path, _path2, _path3, _g, _g2, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivity = function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 240 172"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M120.151 169.862c-45.658 0-82.801-37.146-82.801-82.808 0-15.152 4.127-29.972 11.94-42.861l.768.466c-7.726 12.748-11.81 27.408-11.81 42.395 0 45.165 36.743 81.909 81.903 81.909 45.162 0 81.904-36.744 81.904-81.909 0-45.163-36.742-81.905-81.904-81.905-18.024 0-35.121 5.742-49.442 16.604l-.544-.716c14.48-10.981 31.765-16.786 49.986-16.786 45.659 0 82.801 37.144 82.801 82.803 0 45.662-37.142 82.808-82.801 82.808"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "m186.042 17.58.636.635-59.986 60.08-.635-.635z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BBBDBF",
    d: "M190.387 20.268h-.003a5.86 5.86 0 0 1-5.856-5.855 5.863 5.863 0 0 1 5.859-5.856c1.568 0 3.037.61 4.144 1.717a5.8 5.8 0 0 1 1.709 4.136c-.001 3.231-2.626 5.858-5.853 5.858m.005-10.814a4.97 4.97 0 0 0-4.966 4.958 4.965 4.965 0 0 0 4.958 4.958v.449l.003-.449a4.964 4.964 0 0 0 4.956-4.96 4.9 4.9 0 0 0-1.45-3.502 4.9 4.9 0 0 0-3.501-1.454"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.446 104.905.635.635-30.003 30.028-.635-.634z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.735 144.605h-.003a5.82 5.82 0 0 1-4.139-1.718 5.8 5.8 0 0 1-1.71-4.138 5.86 5.86 0 0 1 5.853-5.857 5.86 5.86 0 0 1 5.859 5.856 5.866 5.866 0 0 1-5.86 5.857m.004-10.815a4.964 4.964 0 0 0-4.958 4.96 4.9 4.9 0 0 0 1.449 3.504 4.92 4.92 0 0 0 3.501 1.453v.448l.003-.448c2.735 0 4.962-2.225 4.962-4.958s-2.224-4.959-4.957-4.959"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBDBF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.146 54.529 36.378 31.762 59.146 8.995l22.765 22.768zM37.647 31.762l21.499 21.495 21.495-21.494-21.495-21.498z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.799 31.234h58.852v.898H29.799z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.893 2.138h.899v58.854h-.899z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "activity_svg__a",
    x1: 106.456,
    x2: 186.88,
    y1: 34.743,
    y2: 98.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#activity_svg__a)",
    d: "M159.005 69.465c-3.771 0-6.839 3.069-6.839 6.841 0 3.771 3.068 6.842 6.839 6.842s6.843-3.07 6.843-6.842-3.071-6.841-6.843-6.841m0 10.088a3.25 3.25 0 0 1-3.246-3.247 3.25 3.25 0 0 1 3.246-3.247 3.25 3.25 0 0 1 3.25 3.247 3.25 3.25 0 0 1-3.25 3.247"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "activity_svg__b",
    x1: 85.651,
    x2: 166.064,
    y1: 61.066,
    y2: 124.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9e1f63"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#activity_svg__b)",
    d: "m169.704 68.218-3.01-3.005a10.7 10.7 0 0 0-7.619-3.157 10.7 10.7 0 0 0-7.62 3.157l-17.613 17.615-18.683-18.68a10.7 10.7 0 0 0-7.62-3.156 10.72 10.72 0 0 0-7.625 3.158l-.497.469a7 7 0 0 0-.704.595L70.648 93.281c-4.2 4.203-4.2 11.041 0 15.244l3.007 3.007a10.7 10.7 0 0 0 7.622 3.157c2.878 0 5.585-1.121 7.62-3.157l18.573-18.574 17.507 17.507a10.4 10.4 0 0 0 1.912 1.492 10.77 10.77 0 0 0 7.161 2.719c2.866 0 5.56-1.116 7.586-3.144l28.068-28.068c4.2-4.206 4.2-11.043 0-15.246m-2.542 12.703-28.065 28.069a7.09 7.09 0 0 1-5.047 2.089 7.2 7.2 0 0 1-4.869-1.894l-.282-.213c-.577-.35-1.015-.682-1.38-1.047L107.47 87.873l-21.113 21.116a7.14 7.14 0 0 1-5.08 2.104 7.13 7.13 0 0 1-5.081-2.104l-3.008-3.006c-2.8-2.801-2.8-7.361 0-10.163l28.068-28.069c.103-.104.22-.187.334-.272l.869-.793a7.15 7.15 0 0 1 5.081-2.103c1.918 0 3.722.747 5.08 2.103l21.223 21.22 20.153-20.155c1.358-1.356 3.161-2.104 5.08-2.104s3.726.747 5.081 2.104l3.006 3.006c2.8 2.803 2.8 7.362-.001 10.164"
  })));
};
export default SvgActivity;